import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@chakra-ui/react'

const InvoiceDetailBlock = ({header, value}) => {
  return (
    <Box width="100px">
      <Text
        textStyle="body-small"
        color="grey.700"
        textAlign="left"
        textTransform="uppercase"
        mb="xxs"
      >
        {header}
      </Text>
      <Text
        textStyle="body-small"
        color="grey.900"
        fontWeight="medium"
        textAlign="left"
      >
        {value}
      </Text>
    </Box>
  )
}

InvoiceDetailBlock.propTypes = {
  header: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
}

export default InvoiceDetailBlock
